import { systemActions } from 'user/redux/slices/systemSlice';
import { store } from 'user/redux/store';

/**
 * [ユーザー画面]非同期関数を並列に実行するラッパー
 * @param promises
 * @returns
 */
export const preloadGroup = async (...promises: (Promise<void> | void)[]): Promise<void> => {
  store.dispatch(systemActions.preloading(true));
  Promise.all(promises).then(() => {
    store.dispatch(systemActions.preloading(false));
  });
};

export default preloadGroup;
